import { render, staticRenderFns } from "./Vehicle.vue?vue&type=template&id=628cc6fc&scoped=true"
import script from "./Vehicle.vue?vue&type=script&lang=js"
export * from "./Vehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628cc6fc",
  null
  
)

export default component.exports